// Generated by ReScript, PLEASE EDIT WITH CARE

import Dayjs from "dayjs";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";

function validateNumber(code) {
  return /^[0-9]+$/.test(code);
}

function getCurrentTime(format) {
  return Dayjs().format(format);
}

function extractParam(key, params) {
  var value = Js_dict.get(params, key);
  if (value !== undefined) {
    return value;
  } else {
    return "";
  }
}

export {
  validateNumber ,
  getCurrentTime ,
  extractParam ,
}
/* dayjs Not a pure module */
